import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import { getFirestore, type Firestore } from "firebase/firestore";
import { firebaseConfig, WEBSITE_DATABASE } from "./firebaseConfig";

let app: FirebaseApp;
let db: Firestore;

function getFirebase(): { app: FirebaseApp; db: Firestore } | null {
  if (!firebaseConfig.projectId) return null;
  if (!app) {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
    db = getFirestore(app, WEBSITE_DATABASE);
  }
  return { app, db };
}

export { getFirebase };
